import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { Stepper as StepperProps } from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'
import UiKitStepper from '@ui-kit/components/Stepper'
import type { Step as StepperStep } from '@ui-kit/components/Stepper/types'

export const Stepper = (props: StepperProps & { flowValues: FlowValues }) => {
  const { t } = useTranslation()
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, {
    flowValues: props.flowValues,
    servicesResponses,
  })

  const translatedSteps = props.steps.map<StepperStep>((step) => {
    return {
      status: step.status,
      title: translateFunction(step.title),
      subtitle: step.subtitle ? translateFunction(step.subtitle) : undefined,
      description: translateFunction(step.description),
    }
  })

  return (
    <View className="p-2.5">
      <UiKitStepper steps={translatedSteps} />
    </View>
  )
}
